import dynamic from "next/dynamic";
import { HeaderLogo as StaticHeaderLogo } from "./logo";

export const DynamicStudentLogo = dynamic(
  () => import("./logo").then((module) => module.HeaderLogo),
  {
    ssr: false,
    loading: () => <StaticHeaderLogo />,
  },
);

export const DynamicTeacherLogo = dynamic(
  () => import("./teacherLogo").then((module) => module.HeaderTeacherLogo),
  {
    ssr: false,
    loading: () => <StaticHeaderLogo />,
  },
);
